import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import MainContent from '../components/layout/MainContent';
import Title from '../components/typography/Title';

import { TaraSearchHeader } from '../components/features/Tara';
import TaraFloatingActionButtonContainer from '../containers/TaraFloatingActionButtonContainer';
import TaraSurveyContainer from '../containers/TaraSurveyContainer';
import SearchResultsContainer from '../containers/SearchResultsContainer';

import { actions } from '../actions/search';
import { actions as taraActions } from '../actions/tara';
import { getIsFetching } from '../reducers/search/isFetching';
import { getSearchQueryText } from '../reducers/search/queryText';
import { getSearchLastQueryText } from '../reducers/search/lastQueryText';
import { getSearchResults } from '../reducers/search/results';
import { getTaraHasMadeIntroduction } from '../reducers/tara/hasMadeIntroduction';
import { getTaraIsViewingSurvey } from '../reducers/tara/isViewingSurvey';

import { createFetchingView } from '../helpers/views';

class SearchView extends React.PureComponent {
  state = {
    hasMadeIntroduction: this.props.hasMadeIntroduction,
  };

  componentDidMount() {
    const { queryText } = this.props.locationPayload;
    const { searchLastQueryText } = this.props;

    if (queryText !== searchLastQueryText) {
      this.props.apiSearchQueryRequest(queryText.toString());
    }

    this.setTaraHasMadeIntroduction();
  }

  componentWillReceiveProps(nextProps) {
    const { queryText } = nextProps.locationPayload;

    if (queryText !== this.props.locationPayload.queryText) {
      this.props.apiSearchQueryRequest(queryText.toString());

      this.setTaraHasMadeIntroduction();

      if (nextProps.hasMadeIntroduction && nextProps.hasMadeIntroduction !== this.state.hasMadeIntroduction) {
        this.setState({ hasMadeIntroduction: true });
      }
    }
  }

  componentWillUnmount() {
    this.setTaraHasMadeIntroduction();
  }

  get shouldRenderTara() {
    const { features, locationQuery } = this.props;

    return !!locationQuery.tara && features.taraSurvey;
  }

  get shouldRenderTaraSurvey() {
    return this.shouldRenderTara && this.props.isViewingSurvey;
  }

  setTaraHasMadeIntroduction = () => {
    const { locationQuery, hasMadeIntroduction } = this.props;

    if (locationQuery.tara && !hasMadeIntroduction) {
      this.props.taraSetHasMadeIntroduction(true);
    }
  };

  renderTitle() {
    const { tara } = this.props.locationQuery;
    const { searchLastQueryText, searchQueryText } = this.props;
    const queryText = searchLastQueryText;

    if (tara) {
      return (
        <TaraSearchHeader
          queryText={queryText}
          searchResults={this.props.searchResults}
          hasMadeIntroduction={this.state.hasMadeIntroduction}
          isFetching={this.props.isFetching}
        />
      );
    }

    return (
      <Title align="center">Search results for "{queryText}"</Title>
    );
  }

  renderContent() {
    return (
      <MainContent
        id="SearchView"
        className="sk-fade-in-quarter-second"
      >
        {this.renderTitle()}

        <SearchResultsContainer />
        {this.shouldRenderTaraSurvey && (<TaraSurveyContainer />)}
        {this.shouldRenderTara && (<TaraFloatingActionButtonContainer />)}
      </MainContent>
    );
  }

  render() {
    if (this.props.isReady) {
      window.CE_SNAPSHOT_NAME = "http://simplifytickets.com/search/texas%20rangers";
      return this.renderContent();
    }

    return null;
  }
}

const mapStateToProps = (state, ownProps) => ({
  isFetching: getIsFetching(state),
  isViewingSurvey: getTaraIsViewingSurvey(state),
  searchLastQueryText: getSearchLastQueryText(state),
  searchQueryText: getSearchQueryText(state),
  searchResults: getSearchResults(state),
  hasMadeIntroduction: getTaraHasMadeIntroduction(state),
  ...ownProps,
});

const mapDispatchToProps = dispatch => bindActionCreators({
  apiSearchQueryRequest: actions.apiSearchQueryRequest,
  taraSetHasMadeIntroduction: taraActions.taraSetHasMadeIntroduction,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(createFetchingView(SearchView));



// WEBPACK FOOTER //
// ./src/views/SearchView.js